export default __webpack_public_path__ + "static/media/mask.77f9790a.svg";